import React from 'react'
import MapaCoordenadaListPageContainer from './MapaCoordenadaListPageContainer'

export class MapaCoordenadaListPage extends React.Component {
  render() {
    return <MapaCoordenadaListPageContainer {...this.props} />
  }
}
